import { gql } from '@apollo/client';
export default gql `
  # The @export directive is part of ApolloClient.
  # We need to manually define it for graphql-inspector to understand it.
  directive @export(as: String) on FIELD
  directive @client on FIELD

  directive @unmask on FRAGMENT_SPREAD | FIELD

  extend type DocumentAssistantPrompt {
    isSystemPrompt: Boolean!
  }

  enum AuthenticatedVar {
    AUTHENTICATED
    NOT_AUTHENTICATED
    NO_USER
  }

  type Profile {
    userId: String!
    email: String!
    preferredLocale: String
    name: String
    picture: String
    verified: Boolean
  }

  extend type Query {
    locale: String!
    marketCode: String!
    storedAccountId: UUID
    touchedEntries: [String!]
    profile: Profile
    authenticated: AuthenticatedVar!
    account: CompanyUser
    accounts: [CompanyUser!]!
  }

  extend type MarketLocale {
    name: String!
    nameInLocalLanguage: String!
    locale: String!
  }

  extend type Market {
    marketLocales: [MarketLocale!]!
  }

  extend type FileSystemDocument {
    body: JSON @deprecated(reason: "Use field 'htmlBody' instead")
  }
`;
